import { createAsyncThunk } from '@reduxjs/toolkit'
import { firestoreService } from '@/services/firebase/firestore.service'
import { GeneralOptions, SiteImages } from '@/types/site.types'
import { where } from 'firebase/firestore'
import { storageService } from '@/services/firebase/storage.service'

/**
 * Fetch sites from Firestore
 * Path: options/general
 * The general document contains a 'sites' array field
 */
export const fetchSites = createAsyncThunk(
  'sites/fetchSites',
  async (_, { rejectWithValue }) => {
    try {
      // Fetch the 'general' document from the 'options' collection
      const generalDoc = await firestoreService.getDocument('options', 'general') as GeneralOptions | null

      if (!generalDoc) {
        return rejectWithValue('General options document not found')
      }

      // Extract the sites array from the document
      const sites = generalDoc.sites || []

      return sites
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch sites')
    }
  }
)

export const fetchSiteImages = createAsyncThunk(
  'sites/fetchSiteImages',
  async (siteId: string | null, { rejectWithValue }) => {
    try {
      let siteImages;
      if (siteId) {
        siteImages = await firestoreService.getDocuments('images', [where('site', '==', siteId)])
      } else {
        siteImages = await firestoreService.getDocuments('images')
      }
      if (!siteImages) {
        return rejectWithValue('Site images document not found')
      }
      return siteImages
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch site images')
    }
  }
)

export const fetchDeleteSiteImage = createAsyncThunk(
  'sites/fetchDeleteSiteImage',
  async ({ imageId, imageName }: { imageId: string, imageName: string }, { rejectWithValue }) => {
    try {
      debugger;
      await firestoreService.deleteDocument('images', imageId)
      await storageService.deleteFile(`images/${imageName}`)
      return imageId
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to delete site image')
    }
  }
)

interface AddSiteImagePayload {
  imageData: SiteImages;
  file: File;
}
export const fetchAddSiteImage = createAsyncThunk(
  'sites/fetchAddSiteImage',
  async ({ imageData, file }: AddSiteImagePayload, { rejectWithValue }) => {

    const fileName = file.name;
    let docId: string | null = null;
    let storagePath: string = '';
    debugger;
    try {
      const existingImages = await firestoreService.getDocuments(
        'images',
        [where('imageUrl', '==', fileName)]
      );
      if (existingImages && existingImages.length > 0) {
        return rejectWithValue("No se pueden agregar fotos con el mismo nombre.");
      }

      const dataToSave = { ...imageData };

      docId = await firestoreService.addDocument('images', dataToSave) as string;
      storagePath = `images/${fileName}`;
      const imageUrl = await storageService.uploadFile(storagePath, file);
      return { ...dataToSave, id: docId, url: imageUrl };

    } catch (error: any) {
      if (docId) {
        await firestoreService.deleteDocument('images', docId).catch(deleteError => {
          console.warn(`Falló la limpieza del documento de Firestore (${docId}): ${deleteError.message}`);
        });
        if (storagePath) {
          await storageService.deleteFile(storagePath).catch(deleteError => {
            console.warn(`Falló la limpieza del archivo de Storage (${storagePath}): ${deleteError.message}`);
          });
        }
      }
      return rejectWithValue(error.message || 'Error al agregar la imagen y subir el archivo. Se intentó hacer Rollback.');
    }
  }
);